import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/api/client';
import { useAuth } from '../../contexts/AuthContext';
import type { LoginRequest, AuthResponse } from '@lov/shared';

export function useLogin() {
  const { login } = useAuth();

  return useMutation({
    mutationFn: async (data: LoginRequest) => {
      const response = await apiClient.post<AuthResponse>('/auth/login', data);
      return response.data;
    },
    onSuccess: (data) => {
      login(data);
    },
  });
}
